import { foldAccents } from "./textFold"; // Tâche 1165

/**
 * Tâche 1164 (Eric 2026-06-17) — Filtre de recherche des parcours.
 *
 * Une SEULE implémentation, partagée par le menu de la fiche du fichier et
 * celui de la liste de l'explorateur. La tâche 1157 a montré ce que coûtent
 * deux copies : le tri avait été corrigé d'un côté seulement.
 *
 * Comparaison sans accent ni casse : « integration » doit trouver
 * « Intégration », sinon le champ ne sert à rien pour un utilisateur pressé.
 */

// Le nom de la FAMILLE compte aussi : taper « integration » doit montrer la
// famille d'intégration, même si aucun parcours ne porte ce mot dans son
// titre (la première version renvoyait une liste vide, ce qui donnait
// l'impression que la recherche était cassée).
const FAMILY_WORDS = {
  onboarding: "integration onboarding",
  learning: "apprentissage learning",
  weekly: "formations hebdomadaires weekly",
};

// Le repli des accents vit dans `textFold` (tâche 1165) : cet alias garde les
// anciens appels valides sans dupliquer la règle.
export { foldAccents as foldText };

export const matchesPathwayQuery = (pathway, query) => {
  // `foldAccents` ne rogne pas les espaces (le surlignage en a besoin tels
  // quels) : on le fait ici, une recherche de blancs ne filtrant rien.
  const needle = foldAccents(query).trim();
  if (!needle) return true;
  if (foldAccents(pathway?.name).includes(needle)) return true;
  return (FAMILY_WORDS[pathway?.pathway_type] || "").includes(needle);
};

export default matchesPathwayQuery;
